import { rollup, sum } from 'd3'

/**
 * Identify if transactions of a date for a Chart of Account have a net zero amount (ie essentially offsetting each other)
 * @param {*} transactions
 */
export function identifyNetZeros (transactions) {
  console.log('identifyNetZeros', transactions)

  const mapByDateAndChartOfAccount = rollup(transactions,
    groupValues => sum(groupValues, d => d.ledger_amount),
    value => value.ledger_date,
    value => value.ledger_accounting_chart_of_account_id
  )

  transactions.forEach(function (transaction) {
    const date = transaction.ledger_date
    const chartOfAccountId = transaction.ledger_accounting_chart_of_account_id
    const netZero = mapByDateAndChartOfAccount.get(date)?.get(chartOfAccountId)

    if (netZero === 0) {
      transaction._isDateChartOfAccountNetZero = true
    }
  })
}
